import Icon from '../components/Icon.vue'

Icon.register({
  'skiing-nordic': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M336 96C362.5 96 384 74.5 384 48S362.5 0 336 0 288 21.5 288 48 309.5 96 336 96zM552 416C538.8 416 528 426.7 528 440 528 453.2 517.2 464 504 464H434.5L460 285.6C471.7 280.9 480.1 269.4 480.1 256 480.1 238.3 465.8 224 448.1 224H404.1L378 170.8C365.5 145.3 342.5 126.6 316.2 119.9L245 98.7C216.7 91.9 187.2 98.2 164.2 115.8L124.5 146.2C110.5 156.9 107.8 177 118.6 191.1 119.3 192 120.3 192.4 121 193.2L66.9 464H24C10.8 464 0 474.7 0 488S10.8 512 24 512H504C543.7 512 576 479.7 576 440 576 426.8 565.2 416 552 416zM291.5 464H194.6L237.7 373 215.7 360C203.6 352.8 193.8 343.1 186.2 332.2L123.7 464H99.5L151.8 202.6C155.9 201.6 159.9 199.7 163.5 197L203.2 166.6C210.9 160.7 220.6 158.6 228.5 160.5L243.2 164.9 205.7 252.3C193.1 281.8 204.4 316.3 232 332.6L317 382.8 291.5 464zM402.1 464H358.5L382.1 388.5C388 367.7 379.2 345.4 360.5 334.1L299.3 298 330.6 219.7 350.9 261.1C358.9 277.4 375.8 288 394 288H427.3L402.1 464z'
      }
    ]
  }
})
